import { defineMessages } from 'react-intl'

export default defineMessages({
  changeSupplier: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.changeSupplier',
    defaultMessage: 'Change supplier',
  },
})
